import push from '../../utils/routing';

/**
 * Navigates screen to the slide editing view for given id
 * @param {string} spaceId
 * @param {string} presentationId
 * @param {boolean} options.endOfPresentation Adds a URL param that allows AppCues to identify
 * the moment when end presentation button is pressed, so that a survey can be displayed.
 */
export default (
    spaceId,
    presentationId,
    { endOfPresentation } = { endOfPresentation: false }
  ) =>
  () =>
    push(
      `/dashboard/${spaceId}/journey/presentation/${presentationId}${
        endOfPresentation ? '?endOfPresentation=true' : ''
      }`
    );
